// Fargelogikk for RackGridV2s farge-lag.
// Inline hex-farger (ikke Tailwind-klasser) slik at lagene ser like ut i lys/grå/mørk
// tema — pastellbakgrunn + mørk tekst er lesbart på alle tre.

import { CellColor } from './types';

/**
 * Kategorisk palett for sone/bintype/prioritet. 16 visuelt adskilte pasteller;
 * flere verdier enn 16 sykler (sjeldent i praksis for disse dimensjonene).
 */
const CATEGORY_PALETTE: CellColor[] = [
    { background: '#bfdbfe', border: '#3b82f6', text: '#1f2937' }, // blå
    { background: '#bbf7d0', border: '#22c55e', text: '#1f2937' }, // grønn
    { background: '#fde68a', border: '#f59e0b', text: '#1f2937' }, // gul
    { background: '#fecaca', border: '#ef4444', text: '#1f2937' }, // rød
    { background: '#e9d5ff', border: '#a855f7', text: '#1f2937' }, // lilla
    { background: '#fbcfe8', border: '#ec4899', text: '#1f2937' }, // rosa
    { background: '#a5f3fc', border: '#06b6d4', text: '#1f2937' }, // cyan
    { background: '#fed7aa', border: '#f97316', text: '#1f2937' }, // oransje
    { background: '#d9f99d', border: '#84cc16', text: '#1f2937' }, // lime
    { background: '#c7d2fe', border: '#6366f1', text: '#1f2937' }, // indigo
    { background: '#99f6e4', border: '#14b8a6', text: '#1f2937' }, // teal
    { background: '#fef08a', border: '#eab308', text: '#1f2937' }, // gull
    { background: '#e5e7eb', border: '#6b7280', text: '#1f2937' }, // grå
    { background: '#fca5a5', border: '#dc2626', text: '#1f2937' }, // mørk rød
    { background: '#93c5fd', border: '#2563eb', text: '#1f2937' }, // mørk blå
    { background: '#86efac', border: '#16a34a', text: '#1f2937' }, // mørk grønn
];

/** Stabil kategorisk farge: verdi-indeks i sortert distinkt-liste → palettfarge */
export const colorForCategoryIndex = (index: number): CellColor =>
    CATEGORY_PALETTE[index % CATEGORY_PALETTE.length];

/** Innholdslag: tom lokasjon */
export const CONTENT_EMPTY: CellColor = { background: '#f1f5f9', border: '#cbd5e1', text: '#64748b' };
/** Innholdslag: lokasjon med saldo */
export const CONTENT_OCCUPIED: CellColor = { background: '#bbf7d0', border: '#22c55e', text: '#1f2937' };

/** Fyllgrad: ukjent kapasitet (saldo finnes, men ingen MaxQuantity registrert) */
export const FILL_UNKNOWN: CellColor = { background: '#e5e7eb', border: '#9ca3af', text: '#374151' };

/**
 * Fyllgrad i prosent → farge. Terskler: <50 grønn, 50–80 gul, 80–100 oransje, >100 rød.
 */
export const colorForFillRate = (pct: number): CellColor => {
    if (pct > 100) return { background: '#fca5a5', border: '#dc2626', text: '#1f2937' };
    if (pct >= 80) return { background: '#fed7aa', border: '#f97316', text: '#1f2937' };
    if (pct >= 50) return { background: '#fde68a', border: '#f59e0b', text: '#1f2937' };
    return { background: '#bbf7d0', border: '#22c55e', text: '#1f2937' };
};
